import { c as _c } from "react/compiler-runtime";
import { FormSuccess } from "@/components/form/form-success.component";
import type { ActionType, ImageType } from "@/lib/types";
export interface WizardSuccessProps<T = unknown> {
  heading?: string | null;
  message: T | null | undefined;
  image?: ImageType | null;
  buttonLabel?: string | null;
  onStartOver?: () => void;
  action?: ActionType | null;
  hideButton?: boolean;
}
export const WizardSuccess = t0 => {
  const $ = _c(8);
  const {
    heading,
    message,
    image,
    buttonLabel,
    onStartOver,
    action,
    hideButton
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== buttonLabel || $[2] !== heading || $[3] !== hideButton || $[4] !== image || $[5] !== message || $[6] !== onStartOver) {
    t1 = <FormSuccess heading={heading} message={message} image={image} buttonLabel={buttonLabel} onStartOver={onStartOver} action={action} hideButton={hideButton} testId="form-wizard-success" />;
    $[0] = action;
    $[1] = buttonLabel;
    $[2] = heading;
    $[3] = hideButton;
    $[4] = image;
    $[5] = message;
    $[6] = onStartOver;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};